/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterGetOrg } from "../../funcs/authClusterGetOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetClusterOrgRequest$inboundSchema,
};

export const tool$authClusterGetOrg: ToolDefinition<typeof args> = {
  name: "auth-cluster-get-org",
  description: `Get an organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterGetOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
